import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import GoogleAuthButton from '../components/GoogleAuthButton';
import { toast } from 'sonner';
import BrandSeal from '../components/BrandSeal';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    const result = await login(email, password);
    
    if (result.success) {
      toast.success('Login successful!');
      navigate('/products');
    } else {
      toast.error(result.error);
    }
    
    setLoading(false);
  };

  return (
    <div className="heritage-page min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="inline-flex flex-col items-center">
            <BrandSeal compact />
            <h1 className="heritage-title mt-4 mb-2 text-5xl tracking-[0.08em]" data-testid="login-logo">Panchami</h1>
          </Link>
          <p className="text-[#6a5448]">Welcome back to your jewelry collection</p>
        </div>

        <div className="heritage-card rounded-sm p-8">
          <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
            <div>
              <Label htmlFor="email" className="text-[#1A1A1A]">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="heritage-input mt-2 rounded-none"
                data-testid="login-email-input"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-[#1A1A1A]">Password</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="heritage-input mt-2 rounded-none"
                data-testid="login-password-input"
              />
            </div>

            <div className="flex justify-end">
              <Link
                to="/forgot-password"
                className="text-sm text-[#8e755d] hover:underline"
                data-testid="forgot-password-link"
              >
                Forgot password?
              </Link>
            </div>

            <Button
              type="submit"
              disabled={loading}
              className="heritage-button w-full rounded-none font-medium uppercase tracking-[0.18em]"
              data-testid="login-submit-btn"
            >
              {loading ? 'Logging in...' : 'Login'}
            </Button>
          </form>

          <div className="mt-6">
            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="heritage-divider w-full border-t"></div>
              </div>
              <div className="relative flex justify-center text-sm">
                <span className="bg-[#faf5ec] px-2 text-[#6a5448]">Or continue with</span>
              </div>
            </div>

            <GoogleAuthButton mode="signin" />
          </div>

          <p className="mt-6 text-center text-[#6a5448]">
            Don't have an account?{' '}
            <Link to="/register" className="text-[#8e755d] hover:underline" data-testid="register-link">
              Register
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
